import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "rounded-xl border border-amber-200 bg-amber-50 p-4"
};
const _hoisted_2 = {
  class: "mt-3 space-y-2"
};
const _hoisted_3 = {
  class: "w-48 shrink-0 text-sm text-slate-600"
};
const _hoisted_4 = ["onUpdate:modelValue", "disabled"];
const _hoisted_5 = {
  class: "flex items-center gap-1 text-xs text-slate-400"
};
const _hoisted_6 = ["checked", "onChange"];
const _hoisted_7 = {
  key: 0,
  class: "mt-2 text-xs text-amber-600"
};
const _hoisted_8 = {
  class: "mt-3 flex justify-end"
};
const _hoisted_9 = ["disabled"];
import { computed, reactive, ref } from 'vue';
export default {
  __name: 'CollectFieldsCard',
  props: {
    snapshot: {
      type: Object,
      required: true
    },
    pending: {
      type: Boolean,
      default: false
    }
  },
  emits: ['resume'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const missing = computed(() => (props.snapshot.interrupt_payload || {}).missing || []);
    const values = reactive({});
    const skipped = ref(new Set());
    function toggleSkip(f) {
      const next = new Set(skipped.value);
      if (next.has(f)) {
        next.delete(f);
        values[f] = values[f] ?? '';
      } else {
        next.add(f);
        delete values[f];
      }
      skipped.value = next;
    }
    function submit() {
      const payload = {
        values: {
          ...values
        }
      };
      if (skipped.value.size) payload.skip = [...skipped.value];
      emit('resume', payload);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "text-sm font-semibold text-slate-800"
      }, "请补充以下企业信息", -1)), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missing.value, f => {
        return _openBlock(), _createElementBlock("div", {
          key: f,
          class: "flex items-center gap-2"
        }, [_createElementVNode("label", _hoisted_3, _toDisplayString(f), 1), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => values[f] = $event,
          class: "form-input form-control-sm flex-1",
          disabled: skipped.value.has(f)
        }, null, 8, _hoisted_4), [[_vModelText, values[f]]]), _createElementVNode("label", _hoisted_5, [_createElementVNode("input", {
          type: "checkbox",
          class: "form-check",
          checked: skipped.value.has(f),
          onChange: $event => toggleSkip(f)
        }, null, 40, _hoisted_6), _cache[0] || (_cache[0] = _createTextVNode(" 无法提供 ", -1))])]);
      }), 128))]), skipped.value.size ? (_openBlock(), _createElementBlock("p", _hoisted_7, " 跳过的字段将无法判定，相关条件会降级为「待人工复核」（NEEDS_REVIEW） ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
        class: "btn-primary form-control-sm",
        disabled: __props.pending,
        onClick: submit
      }, _toDisplayString(__props.pending ? '提交中…' : '提交'), 9, _hoisted_9)])]);
    };
  }
};